import {EntityModel} from '../../../core/model/entity.model';
import {LocalDate} from '@js-joda/core';

export class Holiday extends EntityModel {

  public name?: string;

  public date?: LocalDate;
}
